import React from 'react'
import {
  useFocusable,
  FocusContext,
} from '@noriginmedia/norigin-spatial-navigation'
import tts from '../../../lib/TTS'
import {
  PlayButton,
  PassportButton,
  MyListButton,
  MoreEpisodesButton,
  PreviewButton,
} from './index'
import { useAppSelector } from '../../../hooks/useStore'
import { getQueryParam } from '../../../../../shared/helpers'
import type { ContentActionButtonLabel } from './types'
import { AVAILABILITY, NOT_YET_AVAILABLE } from './utils'

export const CONTENT_BUTTON_FOCUS_KEY = 'CONTENT_BUTTONS'

function ContentButtons() {
  const { ref, focusKey } = useFocusable({
    focusKey: CONTENT_BUTTON_FOCUS_KEY,
  })
  const { videoDetails } = useAppSelector((state) => state.content)

  const setCurrentlyFocusedKeyHandler = (properties: {
    label: ContentActionButtonLabel
  }) => {
    tts.stopRead()
    tts.addTextToRead(`Focused on ${properties.label} button`)
  }

  const onPress = (label: ContentActionButtonLabel) => {
    tts.stopRead()
    tts.clearPushedText()
    tts.addTextToRead(`Selected ${label} button`)
  }

  const availability = getQueryParam(location.search, AVAILABILITY)
  const contentAvailable =
    !videoDetails.expired && availability !== NOT_YET_AVAILABLE

  return (
    <FocusContext.Provider value={focusKey}>
      <div className="video-detail-screen__action-buttons-container" ref={ref}>
        {contentAvailable && (
          <>
            <PlayButton
              onFocus={setCurrentlyFocusedKeyHandler}
              onPress={onPress}
            />
            <PassportButton
              onFocus={setCurrentlyFocusedKeyHandler}
              onPress={onPress}
            />
          </>
        )}
        <MyListButton
          onFocus={setCurrentlyFocusedKeyHandler}
          onPress={onPress}
        />
        <PreviewButton
          onFocus={setCurrentlyFocusedKeyHandler}
          onPress={onPress}
        />
        <MoreEpisodesButton
          onFocus={setCurrentlyFocusedKeyHandler}
          onPress={onPress}
        />
      </div>
    </FocusContext.Provider>
  )
}

export default ContentButtons
